import React, {useState} from 'react'

const CalendarMobile = () => {

const today = new Date();
  const [currentDate, setCurrentDate] = useState(today);

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const firstDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  ).getDay();

  const daysInMonth = getDaysInMonth(
    currentDate.getFullYear(),
    currentDate.getMonth()
  );

  const prevMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
    );
  };

  const nextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
    );
  };

  return (
    <div className="flex items-center justify-center">
      <div className="w-80 bg-white rounded-lg shadow-lg p-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <button
            className="text-gray-500 hover:text-gray-800"
            onClick={prevMonth}
          >
            &#x276E; {/* Left arrow */}
          </button>
          <h2 className="text-lg font-semibold text-gray-700">
            {currentDate.toLocaleString("default", {
              month: "long",
              year: "numeric",
            })}
          </h2>
          <button
            className="text-gray-500 hover:text-gray-800"
            onClick={nextMonth}
          >
            &#x276F; {/* Right arrow */}
          </button>
        </div>

        {/* Days of the Week */}
        <div className="grid grid-cols-7 text-center text-sm text-gray-500 mb-2">
          {daysOfWeek.map((day) => (
            <div key={day} className="font-medium">
              {day}
            </div>
          ))}
        </div>

        {/* Calendar Days */}
        <div className="grid grid-cols-7 gap-1 text-center">
          {/* Empty slots for days before the 1st */}
          {Array.from({ length: firstDayOfMonth }).map((_, i) => (
            <div key={`empty-${i}`} className="py-2"></div>
          ))}

          {/* Days of the month */}
          {Array.from({ length: daysInMonth }, (_, i) => i + 1).map((day) => (
            <div
              key={day}
              className={`py-2 rounded-lg ${
                day === today.getDate() &&
                currentDate.getMonth() === today.getMonth() &&
                currentDate.getFullYear() === today.getFullYear()
                  ? "bg-orange-500 text-white font-semibold"
                  : "text-gray-700"
              } hover:bg-gray-200 transition`}
            >
              {day}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CalendarMobile
